"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function CSquare(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M20.05 2C21.13 2 22 2.87 22 3.95v16.1c0 1.08-.87 1.95-1.95 1.95H3.95C2.87 22 2 21.13 2 20.05V3.95C2 2.87 2.87 2 3.95 2zM20 3.95L3.95 4 4 20.05 20 20V3.95zM12 5c3.859 0 7 3.141 7 7s-3.141 7-7 7-7-3.141-7-7 3.141-7 7-7zm0 2c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm2.607 6.074a2.343 2.343 0 0 1-.361 1.18 2.178 2.178 0 0 1-.924.793 3.169 3.169 0 0 1-1.361.281c-.84 0-1.502-.274-1.987-.822-.482-.547-.724-1.321-.724-2.321v-.316c0-.625.109-1.174.328-1.645.217-.47.531-.834.941-1.089.41-.256.885-.385 1.424-.385.777 0 1.4.205 1.873.613.471.408.738.973.805 1.69h-1.539c-.012-.389-.11-.67-.295-.84-.184-.17-.465-.254-.844-.254-.383 0-.664.142-.844.429-.178.288-.271.747-.281 1.375v.454c0 .683.086 1.171.258 1.462.172.295.467.44.885.44.355 0 .625-.082.814-.25.186-.166.285-.432.299-.795h1.533z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = CSquare;
